import type { FC, ReactNode } from "react";

import type { DocumentItem } from "~/core/deprecated/documents";
import {
  AliPay,
  EighteenPlus,
  FooterLogo,
  KdPay,
  Litecoin,
  Tether,
  WeChatPay,
} from "~/icons";
import { Flex } from "~/shared/ui-kit/flex/Flex";

import { useFooterTranslations } from "./useFooterTranslations";

type FooterProps = {
  renderLink: (url: string, content?: ReactNode) => ReactNode;
  featureFlags: {
    isFooterNavigationLinkEnabled: boolean;
  };
  documents: Array<DocumentItem>;
  language: LanguageCode;
};
export const Footer: FC<FooterProps> = ({
  renderLink,
  featureFlags,
  documents,
  language,
}) => {
  const t = useFooterTranslations();

  return (
    <section className={"py-16 mx-auto w-full"}>
      <div className="">
        <div className="mb-10 flex justify-center">
          <FooterLogo className="scale-75 sm:scale-100" />
        </div>

        <div
          className={
            "font-normal text-[14px] leading-5 sm:text-[16px] text-center text-gray-main sm:leading-6"
          }
        >
          {featureFlags.isFooterNavigationLinkEnabled && (
            <>
              {documents.map((item) => (
                <p className="mt-4" key={item.id}>
                  {renderLink(`documents/${item.id}`, item.subtitle[language])}
                </p>
              ))}
            </>
          )}

          <Flex
            className="max-w-[312px] md:max-w-full mx-auto flex-wrap py-10"
            justify="center"
            gap={16}
          >
            <div className="bg-white/10  w-[100px] h-12 rounded-lg border border-white/25 flex justify-center items-center ">
              {renderLink("/", <Tether />)}
            </div>
            <div className="bg-white/10  w-[100px] h-12 rounded-lg border border-white/25 flex justify-center items-center">
              {renderLink("/", <Litecoin />)}
            </div>
            <div className="bg-white/10 w-[100px] h-12  rounded-lg border border-white/25 flex justify-center items-center">
              {renderLink("/", <WeChatPay />)}
            </div>
            <div className="bg-white/10  w-[100px] h-12 rounded-lg border border-white/25 flex justify-center items-center">
              {renderLink("/", <AliPay />)}
            </div>
            <div className="bg-white/10  w-[100px] h-12  rounded-lg border border-white/25 flex justify-center items-center">
              {renderLink("/", <KdPay />)}
            </div>
          </Flex>
          <div className="text-white/50 font-normal pb-10  ">
            <p className="text-[12px] leading-4 pb-1">
              {t.info.supportDescription}
            </p>
            <span className="text-[#C8A0F0] leading-5 text-[14px]">
              {t.info.supportEmail}
            </span>
          </div>

          <div className="text-white/50 gap-[28px] sm:gap-6 flex-col-reverse sm:flex-col flex">
            <div className=" w-full justify-center">
              <div className="sm:font-medium text-[10px] font-light leading-3 sm:leading-4">
                {t.info.rights}
              </div>
            </div>
            <div className="flex gap-4 justify-center w-[188px] mx-auto items-center text-left">
              <div>
                <EighteenPlus />
              </div>
              <div className="sm:font-medium text-[10px] font-light leading-3 sm:leading-4">
                <p>{t.info.gamblingAddictive}</p>
                <p>{t.info.playResponsibly}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
